import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';
import { convertArrayToTwoDecimalPlaces } from '../../utils';

const defaultData: IDataLayer = {
  enh_action: 'product_click',
  event_category: 'ecommerce',
  event_action: 'product click',
  event_name: 'product_click',
  event_label: null, // '<product name> - <product ID>'
  product_id: null, // '<product ID>'
  product_list: null, // <product location pathname>
  product_position: null, // <product position>
  product_price: null,
  product_product_code: null,
  product_shade: null,
  product_size: null,
  product_sku: null,
  product_name: null
};

function trackProductClick(_: string, eventData: IDataLayer = {}) {
  let data;
  if (eventData && eventData.is_overlay) {
    data = window.page_data?.['analytics-datalayer']?.overlay_datalayer || {};
  } else {
    data = tealium.dataLayer?.data || {};
  }
  let productIndex = -1;
  productIndex = data.product_impression_id?.indexOf(eventData?.product_id[0]);
  if (productIndex >= 0) {
    eventData.event_label = tealium.dataLayer.formatProductEventLabel({
      product_name: [data.product_impression_name[productIndex]],
      product_id: [data.product_impression_id[productIndex]]
    });
    eventData.product_list = [location.pathname];
    eventData.product_list[0] =
      eventData.product_list[0] === '/' ? '/home' : eventData.product_list[0];
    eventData.product_price = convertArrayToTwoDecimalPlaces([
      data.product_impression_price[productIndex]
    ]);
    eventData.product_product_code = [data.product_impression_product_code[productIndex]];
    eventData.product_shade = data.product_impression_shade
      ? [data.product_impression_shade[productIndex]]
      : [null];
    eventData.product_size = data.product_impression_size
      ? [data.product_impression_size[productIndex]]
      : [null];
    eventData.product_sku = [data.product_impression_sku[productIndex]];
    eventData.product_name = [data.product_impression_name[productIndex]];
    tealium.evtLink({ ...defaultData, ...eventData });
  }
}

registerAnalyticsEventHandler('productClick', trackProductClick);
